import { render, staticRenderFns } from "./StartNewSearchPage.container.vue?vue&type=template&id=44bf152c&"
import script from "./StartNewSearchPage.container.vue?vue&type=script&lang=ts&"
export * from "./StartNewSearchPage.container.vue?vue&type=script&lang=ts&"
import style0 from "./StartNewSearchPage.container.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports